module.exports = __webpack_public_path__ + "static/media/shot-daily-ui-001-main.45fe57c3.png";